import React, { useState } from 'react'
import axios from 'axios';
import { AiFillDelete, AiFillEdit, AiOutlineClose } from 'react-icons/ai';
import { ImHistory } from "react-icons/im";
import { RiRoadMapLine } from 'react-icons/ri'
import Swal from 'sweetalert2'
import "./ToDo.min.css";
import { ipAddress } from '../../ipAddress';

interface Props {
  task: Task;
}

interface Task {
  name: string,
  time: string,
  date: string,
  address: string,
  id: number,
  isDone: number,
  dateEnd: string,
  toDoGroupId: number
}

const OneTask: React.FC<Props> = ({ task }) => {

  const [edit, setEdit] = useState<boolean>(false);
  const [editTaskName, setEditTaskName] = useState<string>(task.name);
  const [editTaskTime, setEditTaskTime] = useState<string>(task.time);
  const [editTaskDate, setEditTaskDate] = useState<string>(task.date);
  const [editTaskAddress, setEditTaskAddress] = useState<string>(task.address);
  const [addOption, setAddOption] = useState<boolean>(false);
  const [done, setDone] = useState<boolean>(false);

  const deleteThing = (id: number) => {
    setAddOption(false)
    Swal.fire({
      title: 'Czy jesteś pewien?',
      text: "Element zostanie usunięty",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, move it!',
      heightAuto: false,

    }).then((result) => {
      if (result.isConfirmed) {
        axios.post(ipAddress + '/deleteTask', {
          id: id,
        })
      }
    })

      .then((response) => {

      })

      .catch(function (error) {
        console.log("error!")

      })
  }



  const editTask = (e: React.FormEvent, id: number) => {
    setAddOption(false);
    e.preventDefault();
    axios.post(ipAddress + "/editTask", {
      name: editTaskName,
      time: editTaskTime,
      date: editTaskDate ,
      address: editTaskAddress,
      id: id,
    })
      .then((response) => {

      })
      .catch(err => {
        console.log(err)

      })

    setEdit(false)
  }

  const close = () => {
    setEdit(false);
    setEditTaskName(task.name);
    setEditTaskTime(task.name);
    setEditTaskDate(task.date);
    setEditTaskAddress(task.address)
  }

  const handleChange = (id: number, isDone: number, name: string) => {
    if (isDone == 1) {
      isDone = 0
    } else {
      isDone = 1
    }

    let month = new Date().getMonth() + 1;
    let day = new Date().getDate();
    let year = new Date().getFullYear();
    let date = `${month}/${day}/${year}`;
    Swal.fire({
      title: 'Czy jesteś pewien?',
      text: `Element ${name} zostanie przeniesony do zakończonych`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, move it!',
      heightAuto: false,

    }).then((result) => {
      if (result.isConfirmed) {

        axios.post(ipAddress + '/doneTask', {
          id: id,
          isDone: isDone,
          dateEnd: date
        })
      }
    })


  };
  const resize = () => {
    let element = document.getElementById("textAreaEditTask")
    element.style.height = "5px";
    element.style.height = (element.scrollHeight) + "px";
  }

  let map = `https://maps.google.com/?q=${task.address},Łódź`

  return (
    <div>
      <div className='tasksList'>

        <input type="checkbox"
          className='checkbox'
          checked={false}
          onChange={() => handleChange(task.id, task.isDone, task.name)}
        ></input>
        <span className='description'> {task.name}</span>
        {
         task.time.length > 0 ? (
            <span> Godzina: {task.time}</span>
          ):(
        <div></div>
        )
        }
          {task.date.length > 0 ? (
            <span>Data: {task.date}</span>
          ):(<div></div>)

          }
          {task.address.length > 0 ? (
            //<span>Adres: {task.address}</span>
            <span className='openMap' > {task.address} <a href={map}><RiRoadMapLine /></a></span>
          ):(<div></div>)

          }
        
        


        <span className='edit' onClick={() => setEdit(true)} ><AiFillEdit /></span>
        <span className='delete' onClick={() => deleteThing(task.id)}><AiFillDelete /></span>


      </div>

      {edit ? (
        <form className='taskEdit' onSubmit={(e) => { editTask(e, task.id) }}>
          <button className='icon' id='close' onClick={() => close()} >X</button>
          <p>Edytuj zadanie</p>
          <div className='taskName'>
            <div>
            <label htmlFor="thing">Co: </label>
            <textarea id='textAreaEditTask'
              rows={4}
              value={editTaskName}
              onChange={(e) => (resize(), setEditTaskName(e.target.value))}
            ></textarea>
            </div>
            <div className='container'>
                <label htmlFor='time'>Godzina:</label>
                <input type="time" name='time' id='time' value={editTaskTime} onChange={(e) => setEditTaskTime(e.target.value)} />
                <span className='iconReset' onClick={(e) => ( e.preventDefault(), setEditTaskTime(''))}><ImHistory /></span>
                
              </div>
              <div>
              <label htmlFor='time'>Data:</label>
              <input type="date" name='date' id='date' value={editTaskDate} onChange={(e) => setEditTaskDate(e.target.value)} />
              <span className='iconReset' onClick={(e) => ( e.preventDefault(), setEditTaskDate(''))}><ImHistory /></span>
              </div>
              <div>
              <label htmlFor='time'>Adres:</label>
              <input type="text" name='address' id='address' value={editTaskAddress} onChange={(e) => setEditTaskAddress(e.target.value)}/>
              </div>

          </div>

          <button type='submit' id='submit'>OK</button>
        </form>
      ) : (
        <span></span>
      )
      }
    </div>
  )
}

export default OneTask